// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "../schedule_days_history" // Register local history handling before Turbo.
import "@hotwired/turbo-rails"
import "../controllers"

require("@rails/activestorage").start()
require("channels")

import $ from "jquery"
window.$ = window.jQuery = $

require("popper.js")
import "bootstrap"

require("chosen-js") // after jquery, before controllers
require("js.cookie")

import "chartkick/chart.js"

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
